import { AlterarParagrafo } from '@api/controllers/optiGenerator';

export default class AlterParagraphTune {
  static get isTune() {
    return true;
  }

  constructor({ api, data, block }) {
    this.api = api;
    this.block = block;
    this.data = data || {};
    this.button = null;
  }

  render() {
    this.button = document.createElement('div');
    this.button.classList.add(this.api.styles.settingsButton);
    this.button.innerHTML = `
      <div class="ce-popover-item">
        <div style="width: 15px; margin-right: 10px; margin-left: 5px;" class="ce-popover-item__icon ce-popover-item__icon--tool">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 20h9" />
            <path d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
          </svg>
        </div>
        <div style="padding-right: 68px;" class="ce-popover-item__title">
          Alterar Parágrafo
        </div>
      </div>
      `;

    this.button.title = 'Editar Parágrafo';
    this.button.addEventListener('click', () => {
      this.openToneModal();
    });

    return this.button;
  }

  openToneModal() {
    const modal = document.createElement('div');
    modal.className = 'fixed-tail';
    modal.style.top = '0';
    modal.style.left = '0';
    modal.style.width = '100vw';
    modal.style.height = '100vh';
    modal.style.backgroundColor = 'rgba(0,0,0,0.5)';
    modal.style.display = 'flex';
    modal.style.alignItems = 'center';
    modal.style.justifyContent = 'center';
    modal.style.zIndex = '9999';

    const content = document.createElement('div');
    content.style.background = '#fff';
    content.style.padding = '30px';
    content.style.borderRadius = '10px';
    content.style.minWidth = '300px';
    content.style.boxShadow = '0 5px 15px rgba(0,0,0,0.3)';
    content.innerHTML = `
        <h2 style="margin-bottom: 20px; font-size: 20px;">Descreva a alteração desejada</h2>
        <textarea id="editInstructions" rows="4" placeholder="Ex: Deixe mais objetivo e claro" style="width: 100%; padding: 10px; font-size: 15px; border: 1px solid #ccc; border-radius: 5px;"></textarea>

        <div style="display: flex"> 
          <button id="cancelarButton" style="margin-top: 20px; width: 100%; padding: 10px; background-color: #white; color: black; border: none; border-radius: 5px; font-size: 16px; cursor: pointer;">
            Cancelar
          </button>
          &nbsp;&nbsp;
          <button id="applyTone" style="margin-top: 20px; width: 100%; padding: 10px; background-color: #56a55c; color: white; border: none; border-radius: 5px; font-size: 16px; cursor: pointer;">
            Editar Parágrafo
          </button>
        </div>
      `;

    modal.appendChild(content);
    document.body.appendChild(modal);

    const instructionInput = content.querySelector('#editInstructions');
    const applyButton = content.querySelector('#applyTone');
    const cancelarButton = content.querySelector('#cancelarButton');

    applyButton.addEventListener('click', async () => {
      const instruction = instructionInput.value.trim();
      if (!instruction) return alert('Digite uma instrução para editar o parágrafo.');

      document.body.removeChild(modal);
      await this.applyParagraphEdit(instruction);
    });

    cancelarButton.addEventListener('click', async () => {
      document.body.removeChild(modal);
    });
  }

  async applyParagraphEdit(instrucoes) {
    const savedData = await this.block.save();
    const currentText = savedData.text || savedData.data?.text;
    try {
      const blockId = this.block.id;

      // Mostra texto temporário de loading
      this.api.blocks.update(blockId, {
        text: `✍️ Alterando paragráfo com as instruções “${instrucoes}”...`,
      });

      // Chama sua API
      const response = await AlterarParagrafo({
        Paragrafo: currentText,
        Instrucoes: instrucoes,
      });
      // Atualiza com resposta
      this.api.blocks.update(blockId, {
        text: response.data.paragrafo,
      });
    } catch (error) {
      console.error('Erro ao aplicar as intruções:', error);

      const blockId = this.block.id;
      this.api.blocks.update(blockId, {
        text: currentText,
      });
    }
  }

  save() {
    return this.data;
  }
}
